import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Globe, ArrowUp } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_ec4780e0-2344-45fc-bbeb-d029795156a0/artifacts/umgw06wm_CreduceLogopng.png';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Our Services', path: '/services' },
      { name: 'Projects & Impact', path: '/projects' },
      { name: 'Contact', path: '/contact' }
    ],
    services: [
      { name: 'Carbon Project Development', path: '/services' },
      { name: 'Net Zero Strategy', path: '/services' },
      { name: 'ESG Reporting', path: '/services' },
      { name: 'Carbon Trading', path: '/services' }
    ]
  };

  return (
    <footer className="bg-white border-t border-zinc-200 relative" data-testid="main-footer">
      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="absolute -top-6 right-8 w-12 h-12 bg-[#047857] flex items-center justify-center hover:bg-[#065F46] transition-colors"
        data-testid="footer-back-to-top"
      >
        <ArrowUp className="w-5 h-5 text-white" />
      </button>

      <div className="container mx-auto py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img src={LOGO} alt="Creduce Logo" className="h-12 object-contain" />
            </Link>
            <p className="text-[#52525B] text-sm leading-relaxed mb-6 max-w-md">
              India's leading Carbon Management & Sustainable Solutions company, driving the global transition toward a low-carbon future through innovation, intelligence, and measurable impact.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/envarrior-consulting-services-limited"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-zinc-200 hover:bg-[#047857] hover:border-[#047857] flex items-center justify-center transition-colors group"
                data-testid="footer-linkedin"
              >
                <Linkedin className="w-5 h-5 text-[#52525B] group-hover:text-white transition-colors" />
              </a>
              <a
                href="mailto:marketing@creduce.org"
                className="w-10 h-10 border border-zinc-200 hover:bg-[#047857] hover:border-[#047857] flex items-center justify-center transition-colors group"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-[#52525B] group-hover:text-white transition-colors" />
              </a>
              <a
                href="https://www.creduce.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-zinc-200 hover:bg-[#047857] hover:border-[#047857] flex items-center justify-center transition-colors group"
                data-testid="footer-website"
              >
                <Globe className="w-5 h-5 text-[#52525B] group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#09090B] mb-5">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-[#52525B] hover:text-[#047857] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#09090B] mb-5">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="text-sm text-[#52525B] hover:text-[#047857] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#52525B] text-center md:text-left">
              © {new Date().getFullYear()} Creduce Technologies Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-[#52525B]">
              <button className="hover:text-[#047857] transition-colors">Privacy Policy</button>
              <button className="hover:text-[#047857] transition-colors">ESG Disclosure</button>
              <button className="hover:text-[#047857] transition-colors">Sustainability Policy</button>
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="text-center mt-8 pt-8 border-t border-zinc-200">
          <p className="text-[#52525B] italic">
            "Every Carbon Credit is a Step Toward a Cleaner Tomorrow."
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
